import styled from 'styled-components';

const FlexParent = styled.div`
  display: flex;
`;
export default FlexParent;
